const Builder = require('./BuilderBase');

module.exports = class BlocklyEditor extends Builder {
    constructor(title, properties) {
        super('blocklyView_BlocklyEditor', title, properties);
    }
};
